import React, { useEffect, useState } from 'react';
import { useAuth } from '../../Contexts/AuthContext';
import { Templates_Get_All, Templates_Initialize, Templates_Update } from '../../api/API_Templates'
import UI_Button from '../ERUMAUI/UI_Button';
import UI_Input_Text from '../ERUMAUI/UI_Input_Text';
import UI_Card from '../ERUMAUI/UI_Card';
import Icon_User from '../../Assets/Icons/Icon_User.png';
import Icon_Map from '../../Assets/Icons/Icon_Map.png';
import Icon_Edit from '../../Assets/Icons/Icon_Edit.png';
import Icon_Clock from '../../Assets/Icons/Icon_Clock.png';
import Icon_List from '../../Assets/Icons/Icon_List.png';
import Icon_Calendar from '../../Assets/Icons/Icon_Calendar.png';
import Icon_ReservationSlip from '../../Assets/Icons/Icon_ReservationSlip.png';
import Icon_Template from '../../Assets/Icons/Icon_Template.png';
import Icon_Report from '../../Assets/Icons/Icon_Reports.png';
import Icon_Trail from '../../Assets/Icons/Icon_Trail.png';
import Icon_Settings from '../../Assets/Icons/Icon_Settings.png';
import Icon_Logout from '../../Assets/Icons/Icon_Logout.png';

import { useTemplating } from '../../Contexts/Context_Templating';
import { useAccounts } from '../../Contexts/Context_Accounts';
import { useStatus } from '../../Contexts/Context_Status_Global';
import { useScheduleManagement } from '../../Contexts/Context_ScheduleManagement';
import List_Activities from '../ScheduleManagement/List_Activities';
import UI_Section_Title from '../ERUMAUI/UI_Section_Title';
import UI_Icon from '../ERUMAUI/UI_Icons';
import UI_Divider from '../ERUMAUI/UI_Divider';
import UI_UpdatingStatus from '../ERUMAUI/UI_UpdatingStatus';


export default function Panel_Home_Center() {
    const { Account, Loading, Logout } = useAuth();
    const { Accounts_List_Pending } = useAccounts();
    const { Slide_Switch, Slide_Active } = useStatus();
    const { Schedules_Pending_Initial, Schedules_Pending_Final } = useScheduleManagement();

    if (Loading) {
        return null;
    }
    const Access_InteractiveMap = Account?.Access.InteractiveMap.View;
    const Access_Schedules = Account?.Access.Schedules.View;
    const Access_Reports = Account?.Access.Report.View;
    const Access_Account = Account?.Access.Account.Manage_Others;
    const Access_Templates = Account?.Access.Templating.View;



    return (

        <>
            <h1 className='General_Title' style={{ marginBottom: "10px" }}>
                Welcome back, {Account?.Name_Compounded}.
            </h1>
            {
                (
                    (Access_Account && Accounts_List_Pending.length > 0) || ((Account?.Access.Reservation.Approve.Initial || Account?.Access.Reservation.Approve.Final) && (Schedules_Pending_Initial.length > 0 || Schedules_Pending_Final.length > 0))
                ) ?
                    <>
                        <UI_Section_Title
                            Text="Actions that need your attention"
                            Icon={<UI_Icon Name="Error" />}
                        />
                        <div style={{ display: "flex", flexDirection: "row", flexWrap: "wrap", gap: "10px", marginTop: "10px" }}>
                            {
                                Access_Account && Accounts_List_Pending.length > 0 ?
                                    <UI_Card Type="Home" Shape="Rectangle" Subtype="Pending" Figure={Accounts_List_Pending.length} Text={Accounts_List_Pending.length > 1 ? "Pending registration requests" : "Pending registration request"} Destination='accounts' />
                                    :
                                    ""
                            }
                            {
                                Account?.Access.Reservation.Approve.Initial && Schedules_Pending_Initial.length > 0 ?
                                    <UI_Card Type="Home" Shape="Rectangle" Subtype="Pending" Figure={Schedules_Pending_Initial.length} Text={Schedules_Pending_Initial.length > 1 ? "Reservations for OSA approval" : "Reservation for OSA approval"} Destination='schedules/manage?view=OSA' />
                                    :
                                    ""
                            }
                            {
                                Account?.Access.Reservation.Approve.Final &&
                                    Schedules_Pending_Final.length > 0 ?
                                    <UI_Card Type="Home" Shape="Rectangle" Subtype="Pending" Figure={Schedules_Pending_Final.length} Text={Schedules_Pending_Final.length > 1 ? "Reservations for GSU approval" : "Reservation for GSU approval"} Destination='schedules/manage?view=GSU' />
                                    :
                                    ""
                            }
                        </div>
                    </>
                    :
                    ""
            }

            <UI_Section_Title
                Text="Quick actions"
                Icon={<UI_Icon Name="Action" />}
                Margins={true}
            />
            {(
                Account?.Access?.InteractiveMap?.View ||
                Account?.Acccess?.Reservation?.Create ||
                Account?.Access?.Schedules?.View ||
                Account?.Access?.InteractiveMap?.Edit
            ) ?
                <>
                    {/* <h2 className='General_Paragraph' style={{ marginTop: "10px" }}>
                        Map and Schedules
                    </h2> */}
                    <div style={{ display: "flex", flexDirection: "row", flexWrap: "wrap", gap: "10px", marginTop: "10px" }}>
                        {Account?.Access?.InteractiveMap?.View ?
                            <UI_Card Type="Home" Shape="Square" Icon={Icon_Map} Text="Check currently occupied rooms" Destination='map' />
                            :
                            ""
                        }

                        {Account?.Access?.Reservation?.Create ?
                            <UI_Card Type="Home" Shape="Square" Icon={Icon_Clock} Text="Place a reservation schedule" Destination='schedules/reserve' />
                            :
                            ""
                        }

                        {Account?.Access?.Schedules?.View ?
                            <>
                                <UI_Card Type="Home" Shape="Square" Icon={Icon_List} Text="View all schedules" Destination='schedules?view=Timeline' />
                                <UI_Card Type="Home" Shape="Square" Icon={Icon_Calendar} Text="Open calendar view" Destination='schedules?view=Calendar' />
                            </>
                            :
                            ""
                        }
                    </div>
                </>
                :
                ""
            }

            
            

            
            
            {(Account?.Access?.Report?.View ||
                Account?.Access?.Report?.ScheduleTimetable ||
                Account?.Access?.Report?.RoomUtilization ||
                Account?.Access?.Report?.MapOverview ||
                Account?.Access?.Report?.ReservationSlip ||
                Account?.Access?.Report?.AccountList ||
                Account?.Access?.Report?.ActivityLog
            ) ?
                <>
                    <h2 className='General_Paragraph' style={{ marginTop: "10px", fontWeight: "50" }}>
                        Generate reports
                    </h2>
                    <div style={{ display: "flex", flexDirection: "row", flexWrap: "wrap", gap: "10px", marginTop: "10px" }}>
                        {Account?.Access?.Report?.ScheduleTimetable ?
                            <UI_Card Type="Home" Shape="Square" Icon={Icon_Calendar} Text="Schedule timetable" Destination='reports/timetable' />
                            :
                            ""
                        }

                        {Account?.Access?.Report?.RoomUtilization ?
                            <UI_Card Type="Home" Shape="Square" Icon={Icon_Map} Text="Room utilization" Destination='reports/roomutil' />
                            :
                            ""
                        }

                        {Account?.Access?.Report?.MapOverview ?
                            <UI_Card Type="Home" Shape="Square" Icon={Icon_Map} Text="Map overview" Destination='reports/floorutil' />
                            :
                            ""
                        }

                        {Account?.Access?.Report?.ReservationSlip ?
                            <UI_Card Type="Home" Shape="Square" Icon={Icon_ReservationSlip} Text="Reservation slips" Destination='reports/reservation' />
                            :
                            ""
                        }

                        {Account?.Access?.Report?.AccountList ?
                            <UI_Card Type="Home" Shape="Square" Icon={Icon_User} Text="Account information" Destination='reports/accounts' />
                            :
                            ""
                        }

                    </div>
                </>
                :
                ""
            }


            <div style={{ display: "flex", flexWrap: "wrap", gap: "10px" }}>
                <div>
                    {(
                        Account?.Access?.Templating?.View ||
                        Account?.Access?.Report?.ActivityLog ||
                        Account?.Access?.Account?.Manage_Others ||
                        Account?.Access?.InteractiveMap?.Edit
                    ) ?
                        <>
                            <h2 className='General_Paragraph' style={{ marginTop: "10px", fontWeight: "50" }}>
                                System maintenance
                            </h2>
                            <div style={{ display: "flex", flexDirection: "row", flexWrap: "wrap", gap: "10px", marginTop: "10px" }}>
                                {Account?.Access?.InteractiveMap?.Edit ?
                                    <UI_Card Type="Home" Shape="Square" Icon={Icon_Edit} Text="Edit map data" Destination='map/edit' LoadingScreen={true} />
                                    :
                                    ""
                                }
                                {Account?.Access?.Templating?.View ?
                                    <UI_Card Type="Home" Shape="Square" Icon={Icon_Template} Text="System templating" Destination='templating' />
                                    :
                                    ""
                                }
                                {Account?.Access?.Report?.ActivityLog ?
                                    <UI_Card Type="Home" Shape="Square" Icon={Icon_Report} Text="Activity log" Destination='reports/log' />
                                    :
                                    ""
                                }
                                {Account?.Access?.Report?.ActivityLog ?
                                    <UI_Card Type="Home" Shape="Square" Icon={Icon_Trail} Text="User trail" Destination='reports/usertrail' />
                                    :
                                    ""
                                }

                                {Account?.Access?.Account?.Manage_Others ?
                                    <UI_Card Type="Home" Shape="Square" Icon={Icon_User} Text="Modify user permissions" Destination='accounts' />
                                    :
                                    ""
                                }
                            </div>
                        </>
                        :
                        ""
                    }

                </div>

                <div>
                    <h2 className='General_Paragraph' style={{ marginTop: "10px", fontWeight: "50" }}>
                        You
                    </h2>
                    <div style={{ display: "flex", flexDirection: "row", flexWrap: "wrap", gap: "10px", marginTop: "10px" }}>
                        {Account?.Access?.Account?.Manage_Self ?
                            <UI_Card Type="Home" Shape="Square" Icon={Icon_User} Text="Your account" Destination='user' />
                            :
                            ""
                        }
                        <UI_Card Type="Home" Shape="Square" Icon={Icon_Logout} Text="Log out" onClick={Logout} />
                    </div>
                </div>
            </div>
        </>
    );
}
